import React from "react";
import ConfirmDialog from "../../theme/untitled/ConfirmDialog/ConfirmDialog";
import Icon from "../../theme/untitled/icons/Icon";

const RemoveMemberDialog = ({ row, busy, onClose, onConfirm }) => (
  <ConfirmDialog
    open={!!row}
    onClose={onClose}
    onConfirm={onConfirm}
    icon={<Icon name="Trash01" size={24} />}
    title={row ? `Remove ${row.name}?` : ""}
    confirmLabel={busy ? "Removing…" : "Remove member"}
    busy={busy}
  >
    <p>
      They lose access to this workspace immediately. Calendars and widgets they made stay, and
      the seat is freed.
    </p>
    <p>You can invite them again at any time.</p>
  </ConfirmDialog>
);

export default RemoveMemberDialog;
